import { addAutomation, deleteAutomation, editAutomation, fetchAutomationList, fetchExportData, fetchJsonSchema, getAutomationListCnt, getDartDetails, importData } from './automation_common_func';
import apiCall from '../../utility/api';

type PolicyProps = {
  selectedRowIdInTable: any;
  tenant: string;
  formData: any;
  overlayName: any;
  saveBtnClicked: boolean;
  setSaveBtnClicked: any;
  setOverlayOpen: any;
  setErrorToast: any;
  setToastMessage: any;
  setIsToast: any;
  setExportBtnClicked: any;
  exportBtnClicked: any;
  data: any;
  func: any;
  searchVal: string;
  pageNo: number;
  setTotalPages: any;
  setTotalRecords: any;
  setDartSpecs: any;
  setJsonData: any;
  setUiData: any;
  deleteAutomation: boolean;
  setDeleteAutomation: any;
  setDeleteDisabled: any;
  isRefresh: boolean;
  setRefresh: any;
  setRefreshToast?: any
  isFilter?: boolean
  dropDownValue1?: string
  setIsFilter?: any
  dropdownValue2?: string
  categorySearchVal?: string
  categorySearchData?: any
  setCategorySearchData?: any
  policySearchVal?: string
  setPolicySearchVal?: any
  dropDownValue3?: any
  setPolicySearchData?: any
  policySearchData?: any[]
  setDropDownValue4?: any
  dropDownValue4?: any
  setAdmxData?: any
  setAdmlData?: any
  varvalues?: any
  setDropDownValue3?: any
  setdartid?: any
  dartid?: any
  setExportDetails?: any
  filterArray?: string[]
  setRender?: any
  setFormData?: any
  newData?: any
  rowID?: any
  setSaveConfig?: any
  setUserInput?: any
  setOverlayName?: any
  dartNo: number
  policyArr: any[]
  userInput?: any;
  setLoading?: any;
  setMessage?: any;
  setIsImportProgressLoading?: any;
  setIsCommonToast?: any;
  csvAutomationList?: any;
  setCsvAutomationList?: any;
  setDataInserted?: any;
  setOverlayOpenNew?: any;
  setImportAutomations?: any;
  importAutomations?: any;
  setSubmitDisabled?: any;
}

const policyConfiguration = (props: PolicyProps) => {
  var policyId: any = 2000;
  let category = '';
  let admxl = '';

  const getAutomationList = async (whereCondition: any, limit: any = null, offset: any = null) => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data.length > 0) {
        if (props.overlayName === 'editAutomation') {
          let categoryData = JSON.parse(data[0]?.jsonValue)?.category;
          let subCategoryData = JSON.parse(data[0]?.jsonValue)?.subCategory;

          props.setFormData({
            name: data[0]?.automationName != undefined ? data[0].automationName : "",
            description: data[0]?.description != undefined ? data[0].description : "",
            jsonData: data[0]?.jsonValue != undefined ? JSON.parse(data[0]?.jsonValue).jsonData : "",
            category: categoryData && categoryData[0] != undefined && categoryData[0] != null ? categoryData[0] : [],
            subCategory: subCategoryData && subCategoryData[0] != undefined && subCategoryData[0] != null ? subCategoryData[0] : [],
          });
        } else {
          props.setLoading(true);
          props.func(data);
        }
      } else {
        props.func(data);
      }
    } catch (error) {
      console.log("getAutomationList error=", error);
      props.func([]);
    }
  };

  const getExportData = async (condition: object) => {
    const { data, status } = await fetchExportData(condition);

    if (status === 'success') {
      props.setExportDetails && props.setExportDetails(data);
    }
    props.setExportBtnClicked(false);
  }

  const deleteUnattachedAutomation = async (ids: any) => {
    try {
      const { data, status } = await deleteAutomation(ids, 'policy', props.tenant);

      if (status === 'success' && data.affected_rows > 0) {
        props.setDeleteDisabled(true);
        props.setDeleteAutomation(false);
        props.setIsToast(true);
        getAutomationList({ types: 'policy' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`${props.selectedRowIdInTable.length < 2 ? 'Policy' : 'Policies'} deletion failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      props.setToastMessage(`${props.selectedRowIdInTable.length < 2 ? 'Policy' : 'Policies'} deletion failed`);
      props.setErrorToast(true);
    }
  }

  const getCategories = async () => {
    try {
      const { status, data } = await apiCall(`/automation/getPolicyDetails`, { types: 'policy', category: 'all' });

      if (status === 'success' && data.length > 0) {
        var allCategories = data?.map((item: any) => item);
        var categoriesSet = new Set(allCategories);
        var filteredCategories = Array.from(categoriesSet);

        props.setCategorySearchData(filteredCategories);
        getPolicy();
      }
    } catch (error) {
      console.log("getCategories error=", error);
      props.setCategorySearchData([]);
    }
  };

  const getPolicy = async () => {
    try {
      const { status, data } = await apiCall(`/automation/getPolicyDetails`, { types: 'policy', category: category });

      if (status === 'success' && data.length > 0) {
        const allSubCategories = data.map((item: any) => item);
        const subCategoriesSet = new Set(allSubCategories);
        const filteredCategories = Array.from(subCategoriesSet);

        props.setPolicySearchData(filteredCategories);
      }
    } catch (error) {
      console.log("getPolicy error=", error);
      props.setPolicySearchData([]);
    }
  };

  const getAdmxl = async () => {
    try {
      const { status, data } = await apiCall(`/automation/getPolicyDetails`, { types: 'policy', category: category, subCategory: admxl });

      if (status === 'success' && data.length > 0) {
        let formatedADML = data.map((item: any) => (item.ADML)).join("\n");
        // console.log("formatedADML", formatedADML);
        props.setAdmlData(formatedADML);
        policyId = 2000;
        // setPolicyName(data.core_AdmxAdml[0].policy_name);
        let formatedAXML = data.map((item: any) => (item.ADMX)).join("\n");
        props.setAdmxData(formatedAXML);
        props.setRender(true);
        // console.log("formatedAXML", formatedAXML);
      }
    } catch (error) {
      console.log("getAdmxl error=", error);

    }
  };

  const getJsonSchema = async (dartid: number) => {
    try {
      const { data, status } = await fetchJsonSchema(dartid);

      if (status === 'success' && data?.length > 0) {
        var uiSchema = JSON.parse(data[0]?.uiSchema);
        uiSchema["ui:submitButtonOptions"] = {
          "norender": true,
        };

        var jsonSchemaData = JSON.parse(data[0]?.jsonSchema);

        data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
        data[0]?.uiSchema != undefined && props.setUiData(uiSchema);
      }
    } catch (error) {

    }
  };

  const createAutomation = async (automationName: string, description: string, jsonValue: string, policyArr: any[], dartid: number, tenant: string, userInput: any) => {
    try {
      const { status } = await apiCall(`/automation/add`, {
        types: 'policy',
        tenant: tenant,
        name: automationName,
        description: description,
        formData: jsonValue,
        policy: policyArr,
        dartNo: dartid,
        userInput: userInput
      });

      if (status === 'success') {
        props.setDropDownValue3([]);
        props.setDropDownValue4([]);
        props.setIsToast(true);
        props.setSaveBtnClicked(false);

        setTimeout(() => {
          props.setSaveConfig(false);
        }, 1000);
        props.setUserInput({});

        // getAutomationList({ dartid: dartid, types: 'policy' }, 50, parseInt(props.pageNo));
        getAutomationList({ types: 'policy' }, 50, props.pageNo);
        getAutomationListCnt({ types: 'policy' }, props.setTotalRecords, props.setTotalPages);
      } else {
        props.setToastMessage(`${automationName} policy automation creation failed`);
        props.setErrorToast(true);
        props.setSaveBtnClicked(false);
        props.setSaveConfig(false);
      }
    } catch (error) {
      console.log("createAutomation error=", error);

      props.setToastMessage(`${automationName} policy automation creation failed`);
      props.setErrorToast(true);
      props.setSaveBtnClicked(false);
      props.setSaveConfig(false);
    }
  }

  const modifyAutomation = async (automationName: string, description: string, jsonVal: string, policyArr: any[], dartid: number, id: number, tenant: string, userInput: any) => {
    try {
      const { status } = await apiCall(`/automation/update`, {
        types: 'policy',
        tenant: tenant,
        id: id,
        name: automationName,
        description: description,
        formData: jsonVal,
        policy: policyArr,
        dartNo: dartid,
        userInput: userInput
      });

      if (status === 'success') {
        props.setIsToast(true);

        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveConfig(false);
        }, 1000);
        props.setUserInput({});

        getAutomationList({ types: 'policy' }, 50, props.pageNo);
        getAutomationListCnt({ types: 'policy' }, props.setTotalRecords, props.setTotalPages);
      } else if (status === 'failed') {
        props.setOverlayOpen(false);
        props.setToastMessage("This policy can't be edited as it is already configured");
        props.setErrorToast(true);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      } else {
        props.setToastMessage(`Error occured while saving ${automationName} policy automation`);
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      }
    } catch (error) {
      console.log("modifyAutomation error=", error);

      props.setToastMessage(`Error occured while saving ${automationName} policy automation`);
      props.setErrorToast(true);
      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setSaveBtnClicked(false);
      }, 1000);
    }
  }

  props.categorySearchData.length === 0 && getCategories();

  const insertAutomationData = async () => {
    if (props.csvAutomationList.length > 0) {
      console.log('props.csvAutomationList ->', props.csvAutomationList);
      const cleanedList = [
        props.csvAutomationList[0],
        ...props.csvAutomationList.slice(1).filter(row => row.length > 0 && row.some(cell => cell !== ''))
      ];
      try {
        const resp = await importData(cleanedList);
        if(resp.status === 'success') {
          props.setMessage({ type: 'success', text: resp.msg });
          props.setDataInserted(true);
          props.setImportAutomations(false);
          props.setIsImportProgressLoading(false);
          props.setCsvAutomationList([]);
          props.setSubmitDisabled(false);
          console.log("Data inserted successfully");
          props.setOverlayOpenNew(false);
          props.setIsCommonToast(true);
          setTimeout(() => {
              props.setIsCommonToast(false);
          }, 3000);
        }else{
          // props.setMessage({ type: 'error', text: resp.msg });
          props.setIsImportProgressLoading(false);
          console.error("Error inserting automation data:", resp.msg);
          props.setMessage({ type: 'error', text: resp.msg });
          props.setOverlayOpenNew(false);
          props.setImportAutomations(false);
          props.setIsImportProgressLoading(false);
          props.setCsvAutomationList([]);
          props.setSubmitDisabled(false);
          props.setIsCommonToast(true);
          setTimeout(() => {
              props.setIsCommonToast(false);
          }, 3000);
        }
      } catch (error) {
        props.setMessage({ type: 'error', text: 'Automation import failed!' });
        props.setIsImportProgressLoading(false);
        props.setIsCommonToast(true);
          setTimeout(() => {
              props.setIsCommonToast(false);
          }, 3000);
        props.setImportAutomations(false);
        props.setIsImportProgressLoading(false);
        props.setCsvAutomationList([]);
        props.setSubmitDisabled(false);
        console.error("Error inserting automation data:", error);
        // props.setMessage({ type: 'error', text: 'Automation insertion failed!' });
        props.setOverlayOpenNew(false);
      }
    }
  };

  if (props.isRefresh === false && props.deleteAutomation === false && props.overlayName === '') {
    getJsonSchema(props.dartNo);
    getDartDetails(props.dartNo, props.setDartSpecs);
  } else if (props.isRefresh) {
    props.setRefresh(false);
    props.setRefreshToast(true);

    getAutomationListCnt({ types: 'policy' }, props.setTotalRecords, props.setTotalPages);
    getAutomationList({ types: 'policy' }, 50, props.pageNo);
    setTimeout(() => {
      props.setRefreshToast(false);
    }, 3000);
  }

  if (props.searchVal?.length > 0) {
    getAutomationList({ function: 'search', types: 'policy', search: props.searchVal }, 50, props.pageNo);
    getAutomationListCnt({ function: 'search', types: 'policy', search: props.searchVal }, props.setTotalRecords, props.setTotalPages);
  }

  if (props.isFilter === true) {
    const whereCondition = { types: "policy", function: 'filter', filter: props.filterArray };
    getAutomationList(whereCondition, 50, props.pageNo);
    getAutomationListCnt(whereCondition, props.setTotalRecords, props.setTotalPages);
  } else if (props.deleteAutomation && props.selectedRowIdInTable.length > 0) {
    deleteUnattachedAutomation(props.selectedRowIdInTable);
  } else if (props.saveBtnClicked && props.newData !== undefined && Object.keys(props.newData).length > 0) {
    props.saveBtnClicked && props.overlayName === 'addAutomation' && props.overlayName !== '' && policyId !== null && createAutomation(props.newData.name, props.newData.description, props.newData, props.policyArr, props.dartNo, props.tenant, props.userInput);

    props.saveBtnClicked && props.overlayName === 'editAutomation' && modifyAutomation(props.newData.name, props.newData.description, props.newData, props.policyArr, props.dartNo, props.rowID, props.tenant, props.userInput);
  } else if (props.exportBtnClicked) {
    getExportData({ types: 'policy', function: 'export', tenant: props.tenant });
  } else if (props.importAutomations) {
    insertAutomationData();
  } else {
    props.overlayName === '' && !props.saveBtnClicked && getAutomationList({ types: 'policy' }, 50, props.pageNo);

    props.overlayName === '' && !props.saveBtnClicked && getAutomationListCnt({ types: 'policy' }, props.setTotalRecords, props.setTotalPages);
  }

  category = props?.dropDownValue3?.length > 0 ? props?.dropDownValue3[0] : "";
  admxl = props?.dropDownValue4?.length > 0 ? props?.dropDownValue4[0] : "";

  if (props?.dropDownValue3?.length > 0 || props?.formData?.category?.length == true) {
    getPolicy();
  }

  if (props?.dropDownValue4?.length > 0 || props?.formData?.subCategory?.length == true) {
    getAdmxl();
  }

  if (!(props.saveBtnClicked) && props.overlayName === 'editAutomation') {
    getAutomationList({ types: 'policy', id: props.rowID }, null, null);
  }
}

export { policyConfiguration }